import type { MarketBrief, RadarDraftInput } from './types';

export type OutreachForm = Omit<RadarDraftInput, 'id' | 'contact_id' | 'channel'>;
export const requiredOutreachFields = ['sender_name', 'seller_company', 'claims', 'objective'] as const;

export function sourceDomain(source?: string | null) {
  if (!source) return '';
  try {
    const url = new URL(source);
    return /^https?:$/.test(url.protocol) ? url.hostname.replace(/^www\./, '') : '';
  } catch { return ''; }
}

// Accept the persisted, confirmed brief only. Buyer requirements are not seller claims.
export function outreachDefaults(merchantName: string, brief: MarketBrief | null | undefined,
  language: RadarDraftInput['language']): OutreachForm {
  const claims = [brief?.seller_summary, ...(brief?.products || [])]
    .map(value => value?.trim()).filter((value): value is string => !!value);
  return {
    // A reference/product URL can belong to a manufacturer or marketplace.
    // It does not establish the sender's company affiliation.
    sender_name: merchantName.trim().slice(0, 100), seller_company: '',
    claims: [...new Set(claims)].join('\n').slice(0, 2000), objective: (brief?.relationship_goal || '').trim().slice(0, 500),
    signature: '', tone: 'concise', language,
  };
}
